module.exports = __webpack_public_path__ + "static/media/zarapreowned.0615c5e3.svg";